import type { CartItemsLocal, CartProductLocal } from '~/types/local-types'
import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
import mapValues from 'lodash.mapvalues'
import pickBy from 'lodash.pickby'
import { hash } from 'ohash'
import { shop } from '~/store/shop'

export function getCartProductId (product: any) {
    product = cleanProduct(product)
    product = Object.fromEntries(
        Object.entries(product).filter(([ key ]) => [ 'id', 'extras', 'note' ].includes(key))
    )
    return hash(product)
}

export function cleanProduct (product: CartProductLocal) {
    if (product?.extras) {
        // remove the extra items that are not true
        product.extras = mapValues(product.extras, (extra: CartItemsLocal) => {
            return mapValues(extra, extraItem => {
                return pickBy(extraItem, (value: any) => {
                    return Number(value.quantity) > 0
                })
            })
        })
        // remove the extras that are empty
        product.extras = pickBy(product.extras, (extra: CartItemsLocal) => {
            return Object.keys(extra.items).length > 0
        })
        if (product.extras && Object.keys(product.extras).length === 0) {
            delete product.extras
        }
    }
    return product
}

export function predictPriceOfProduct (product: ProductOrderBuddy, cartProduct: CartProductLocal) {
    const currentProductPrice: number = Number(product?.price) || 0
    const currentExtrasPrice = (): number => {
        let extrasTotal = 0
        if (cartProduct?.extras && Object.keys(cartProduct?.extras).length) {
            extrasTotal = Object.values(cartProduct.extras).reduce((total: number, extra: any) => {
                const selectedExtraItems: string[] = Object.keys(extra.items).filter(itemKey => extra.items[itemKey].selected)
                selectedExtraItems.forEach((itemKey: string) => {
                    const extraItems = product.extras?.flatMap(({ items }) => items) || []
                    if (extraItems) {
                        const extraItem = extraItems.find(item => item?.id === itemKey) || null
                        if (extraItem) {
                            // TODO: it would be better to not have to use the shop() store here, since utils should be JS only
                            const price = extraItem.price === null && extraItem.id.split('-p')[1] ? shop().findProduct(extraItem.id.split('-p')[1])?.price : extraItem.price // if the extra item has a product id, get the price from the shop
                            total += Number(price) * Number(extra.items[itemKey].quantity)
                        }
                    }
                })
                return Number(total)
            }, 0)
        }
        return extrasTotal
    }
    return currencyFormat((currentProductPrice + currentExtrasPrice()) * cartProduct.quantity)
}
